import { Box, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Pencil } from 'src/assets/svg/pencil.svg';
import { BookingDetailsDialog } from 'src/features/booking-details-dialog';
import { UserChoices } from 'src/shared/types/user-choices';
import { BookingCalculatedDetails } from 'src/api/bookingService';
import { ApiBasket } from 'src/api/basketService';

import { BookingDetailsContent } from './booking-details-content';
import { styles } from './styles';

export type YourBookingDetailsProps = {
    calculatedBookingDetails: BookingCalculatedDetails;
    userChoices: UserChoices;
    basket: ApiBasket;
};

export const YourBookingDetails: FC<YourBookingDetailsProps> = ({
    calculatedBookingDetails,
    userChoices,
    basket,
}) => {
    const { t } = useTranslation();
    const roomData = calculatedBookingDetails.room;

    useEffect(() => {
        window.dataLayer.push({
            event: 'booking_details',
        });
    }, []);

    const [isEditOpen, setIsEditOpen] = useState<boolean>(false);

    const handleIsEditOpen = () => {
        setIsEditOpen((prev) => !prev);
    };

    return (
        <Box css={styles.wrapper}>
            <Box css={styles.header}>
                <Typography css={styles.title} variant="h2">
                    {t('your_details_booking_details')}
                </Typography>
                <Pencil css={styles.icon} onClick={handleIsEditOpen} />
            </Box>
            <BookingDetailsContent roomData={roomData} userChoices={userChoices} />
            <BookingDetailsDialog
                isOpen={isEditOpen}
                handleIsOpen={handleIsEditOpen}
                calculatedBookingDetails={calculatedBookingDetails}
                userChoices={userChoices}
                basket={basket}
            />
        </Box>
    );
};
